export const signupUser = async (formData) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/signup/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Failed to signup");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(`API Error: ${error.message}`);
  }
};
